import React from "react";
import { ToolButtonStyeld } from "./styles.web";
function DocumentTool({ renderMenu, children }) {
    return (React.createElement(ToolButtonStyeld, { ...APP.config.ui.document },
        renderMenu(),
        children));
}
export default React.memo(DocumentTool);
